/* global $:false */

export default class RegistrationForm {
  static init () {
    Array.from($('.js-registration-form')).map((el) =>
      (this.singleton = new RegistrationForm(el)))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.setupBindings()
    // After submit, the input may be pre-populated. So force-refresh
    // status.
    this.toggleSubmit()
  }

  findElements () {
    this.email = this.el.find('.js-registration-form__email')
    this.submit = this.el.find('.js-registration-form__submit')
  }

  setupBindings () {
    this.email.change(() => this.toggleSubmit())
    this.email.keyup(() => this.toggleSubmit())
  }

  toggleSubmit () {
    if (this.validEmailSyntax()) {
      this.submit.removeAttr('disabled')
    } else {
      this.submit.attr('disabled', 'disabled')
    }
  }

  validEmailSyntax () {
    return /\S+@\S+\.\S+/.test(this.email.val())
  }
}
